import { Component, Input } from '@angular/core'

@Component({
  selector: 'single-select-option',
  template: require('./single-select-option.component.html')
})

export class SingleSelectOptionComponent {
  @Input() private option: Object
  @Input() private level: number
  @Input() private selectedValue: any
  @Input() private selectOptionFn: Function

  private select() {
    if(!this.selectable()) { return }
    this.selectOptionFn(this.option)
  }

  private selectable(): boolean {
    return !this.option['group'] && !this.option['disabled']
  }

  private selected(): boolean {
    return this.selectedValue == this.option['value'] && !this.option['group']
  }

  trackByFn(index, item) {
    return item["group"] ? 
      item["label"] : item["value"]
  }
}



// WEBPACK FOOTER //
// ./~/angular2-template-loader!./~/angular-router-loader/src!./app/common/forms/single-select-option.component.ts